/**
 * v2 mutation keys for user preferences.
 *
 * The read hook still lives in the legacy `orbit-service-ts/user-preferences`
 * tree because legacy code consumes it too. The cache namespace it uses is
 * `['userPreferences']`, which we re-export here so v2 mutations can
 * invalidate that exact namespace on success.
 */
import { userPreferencesKeys as legacyUserPreferencesKeys } from 'src/data/api/orbit-service-ts/user-preferences/queries/keys';

/** Cache namespace shared with legacy reader. Used for invalidation. */
export const sharedUserPreferencesKeys = legacyUserPreferencesKeys;

/** v2-owned mutation keys, namespaced so they don't collide with anything. */
export const v2UserPreferencesMutationKeys = {
  all: ['v2', 'userPreferences'] as const,
  update: (key: { programId: string | undefined; userId: string | undefined }) =>
    [...v2UserPreferencesMutationKeys.all, 'update', key.programId, key.userId] as const,
};
